var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSupport28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 26c6.627 0 12-5.373 12-12S20.627 2 14 2 2 7.373 2 14s5.373 12 12 12Zm.193-19.65c-.711 0-1.466.114-2.261.339-.799.21-1.51.52-2.132.93-.405.265-.672.58-.774.953-.097.356-.074.691.078.995.152.305.4.51.735.61l.008.002c.363.087.76-.013 1.178-.26a7.07 7.07 0 0 1 1.413-.631l.003-.001a4.957 4.957 0 0 1 1.574-.237c.633 0 1.099.137 1.418.39.317.25.477.59.477 1.038 0 .39-.09.76-.272 1.108l-.002.005c-.169.35-.483.782-.953 1.297h-.002c-.628.704-1.083 1.361-1.358 1.973l-.001.002c-.26.613-.39 1.27-.39 1.97 0 .335.08.622.253.848l.009.01c.196.213.461.315.777.315.29 0 .536-.073.72-.237a.849.849 0 0 0 .318-.608 3.88 3.88 0 0 1 .492-1.408c.255-.44.723-.975 1.415-1.609.777-.702 1.325-1.36 1.633-1.976a4.2 4.2 0 0 0 .483-1.98c0-.768-.208-1.444-.628-2.02-.403-.573-.974-1.018-1.706-1.339-.719-.32-1.555-.479-2.505-.479Zm-.266 12.711c-.538 0-.985.167-1.329.51-.328.329-.488.754-.488 1.262 0 .522.16.96.486 1.304l.002.002c.344.344.791.511 1.329.511.549 0 .993-.166 1.31-.515.325-.342.484-.78.484-1.302 0-.506-.16-.93-.486-1.259-.316-.348-.76-.513-1.308-.513Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport28);
export default __webpack_public_path__ + "static/media/support_28.072a555a.svg";
export { ForwardRef as ReactComponent };